<script>
import utility from '../../../mixins/utility';

export default {
  name: 'Weekday',
  mixins: [
    utility,
  ],
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      modifiableData: undefined,
    };
  },
  computed: {
    isValid() {
      return Object.values(this.modifiableData).some(value => value);
    },
  },
  methods: {
    dataChanged() {
      this.$emit('valid', this.isValid);
      this.$emit('update:data', this.modifiableData);
    },
  },
  created() {
    this.modifiableData = {
      monday: this.data.monday || false,
      tuesday: this.data.tuesday || false,
      wednesday: this.data.wednesday || false,
      thursday: this.data.thursday || false,
      friday: this.data.friday || false,
      saturday: this.data.saturday || false,
      sunday: this.data.sunday || false,
    };
    this.dataChanged();
  },
};
</script>

<template>
  <v-layout row wrap>
    <v-flex v-for="(value, weekday) in modifiableData" :key="weekday" xs3>
      <v-checkbox
        v-model="modifiableData[weekday]"
        :label="weekday | capitalizeFirstLetter"
        hide-details
        @change="dataChanged"
      />
    </v-flex>
  </v-layout>
</template>



// WEBPACK FOOTER //
// src/components/Triggers/TriggerRuleSettingTypes/Weekday.vue